/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontSocialShare_seller$ref: FragmentReference;
export type StorefrontSocialShare_seller = {|
  +sellerProfile: ?{|
    +company: ?string
  |},
  +$refType: StorefrontSocialShare_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontSocialShare_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'dc831e75325ac9ff6898dfc6223ab2ff';
module.exports = node;
